<template>
  <div class="flex-start-md">
    <p>
      <i18n-t keypath="NotificationsComponent.NextTierNotAvailableForSeatUpgrade" tag="span" scope="global">
        <template #overDevices>
          {{ overDevices }}
        </template>
        <template #contactSupport>
          <strong>
            {{ t("Common.contactSupport") }}
          </strong>
        </template>
      </i18n-t>
    </p>
  </div>
</template>

<script setup lang="ts">
import { PropType, computed } from "vue";
import { INotification } from "@/stores/notificationsInterfaces";
import { t } from "@/i18n";

const props = defineProps({
  notification: {
    type: Object as PropType<INotification>,
    required: true,
  },
});

const overDevices = computed(() => {
  const params = props.notification?.params;
  // Use new descriptive names with fallback to legacy digit properties
  const activeDevices = params?.seatEnforcementParams?.activeDevices ?? 0;
  const planDevices = params?.seatEnforcementParams?.planDevices ?? 0;
  return activeDevices - planDevices;
});
</script>
